import {gql} from 'graphql-request';

// Every SaaS, including disabled ones, with the clients it is restricted to.
// An empty client_ids list means the SaaS is available to all clients.
export const saasClientRestrictionsQuery = gql`
query SaasClientRestrictions {
    saas_client_restrictions {
        name
        description
        is_disabled
        restricted
        client_ids
    }
}`;

// restricted=false makes the SaaS available to all clients again;
// restricted=true needs at least one client.
export const setSaasClientRestrictionMutation = gql`
mutation SetSaasClientRestriction($saas: String!, $restricted: Boolean!, $client_ids: [uuid!]!){
  set_saas_client_restriction(saas: $saas, restricted: $restricted, client_ids: $client_ids) {
    saas
    restricted
    client_ids
  }
}`;

// Enables (is_disabled=false) or disables a SaaS for every client.
// A disabled SaaS is left out of every client's add-SaaS catalogue
// and its connections are hidden; nothing is deleted.
export const setSaasDisabledMutation = gql`
mutation SetSaasDisabled($saas: String!, $is_disabled: Boolean!){
  set_saas_disabled(saas: $saas, is_disabled: $is_disabled) {
    saas
    is_disabled
  }
}`;
